var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: { width: _vm.width, visible: _vm.visible, footer: null },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "div",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _c(
        "a-carousel",
        { ref: "carouselRef", attrs: { arrows: "", autoplay: "" } },
        [
          _c(
            "div",
            {
              staticClass: "custom-slick-arrow",
              staticStyle: { left: "10px", "z-index": "1" },
              attrs: { slot: "prevArrow" },
              slot: "prevArrow",
            },
            [_c("a-icon", { attrs: { type: "left-circle" } })],
            1
          ),
          _c(
            "div",
            {
              staticClass: "custom-slick-arrow",
              staticStyle: { right: "10px" },
              attrs: { slot: "nextArrow" },
              slot: "nextArrow",
            },
            [_c("a-icon", { attrs: { type: "right-circle" } })],
            1
          ),
          _vm._l(_vm.urlList, function (url, index) {
            return _c("div", { key: index, staticStyle: { width: "90%" } }, [
              _c("img", {
                staticStyle: {
                  width: "100%",
                  height: "550px",
                  "object-fit": "contain",
                },
                attrs: { src: url, alt: "" },
              }),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }